import axios from 'axios'
import apiEndpoints from '@/constants/apiEndpoints'

export default {
  methods: {
    async fetchPhotoUrl(filename) {
      if (!filename) return null
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_DOWNLOAD_ASSET}`,
          { ObjectName: filename },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${this.$cookies.get('userToken')}`,
            },
          },
        )
        if (response.data.Status === 1) return response.data.Payload
        return null
      } catch {
        return null
      }
    },
  },
}
